module.exports = __webpack_public_path__ + "img/shrimp_th_new_0004.cf7aac87.png";